import { useState, useEffect } from "react"
import Router from "next/router"
import qs from "qs"

import useDebounce from "./useDebounce"

import { SearchState } from "react-instantsearch-core"

export const urlToSearchState = (asPathIncludingQueryParams: string) => {
	if (!asPathIncludingQueryParams.includes("?")) return {}

	const searchQueryParams = asPathIncludingQueryParams.replace(/^.+\?/, "")
	const searchState = qs.parse(searchQueryParams) as SearchState

	delete searchState["locale"]
	delete searchState["slug"]

	return searchState
}

export const createSearchQueryParams = (searchState: SearchState) => `?${qs.stringify(searchState)}`

const useAlgoliaURLSync = (
	initialSearchState: SearchState,
	fsPathName: string,
	asPath: string,
	debounceMs = 800,
) => {
	const [searchState, onSearchStateChange] = useState(initialSearchState)
	const debouncedSearchState = useDebounce(searchState, debounceMs)

	const asPathWithoutSearchQueries = asPath ? asPath.replace(/\?\S+/, "") : ""

	useEffect(() => {
		// Restore search state on client-side back navigation
		const urlHasSearchQuery = window.location.href.includes("?")
		if (Object.keys(initialSearchState).length === 0 && urlHasSearchQuery) {
			onSearchStateChange(urlToSearchState(window.location.href))
		} else onSearchStateChange(initialSearchState)
	}, [initialSearchState, asPathWithoutSearchQueries])

	useEffect(() => {
		if (Object.keys(debouncedSearchState).length !== 0) {
			const searchQueryParams = createSearchQueryParams(debouncedSearchState)

			const updatedPath = `${asPathWithoutSearchQueries}${searchQueryParams}`
			Router.push(fsPathName, updatedPath, {
				shallow: true,
			})
		}
		// eslint-disable-next-line
	}, [debouncedSearchState, fsPathName])

	return [searchState, onSearchStateChange] as [
		SearchState,
		(nextSearchState: SearchState) => void,
	]
}

export default useAlgoliaURLSync
